<div class="modal-header">
  <h5 class="modal-title">{{ 'MASS_ADD_TRANSLATIONS_TITLE' | translate }}</h5>
  <button type="button" class="close" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <ng-container *ngIf="view === 'input'">
    <p>{{ 'MASS_ADD_TRANSLATIONS_HELP' | translate }}</p>
    <pre class="example-block">{{ exampleText }}</pre>
    <div *ngIf="allLanguages?.length" class="supported-languages mb-2">
      <p class="mb-1">{{ 'MASS_ADD_TRANSLATIONS_SUPPORTED_LANGUAGES' | translate }}</p>
      <div>
        <span class="badge badge-light mr-1 mb-1" *ngFor="let lang of allLanguages">{{ lang }}</span>
      </div>
    </div>
    <textarea class="form-control" rows="14" [(ngModel)]="rawInput"></textarea>
    <div *ngIf="globalParseError" class="alert alert-danger mt-2">
      {{ 'MASS_ADD_TRANSLATIONS_PARSE_ERROR' | translate }}
    </div>
  </ng-container>

  <ng-container *ngIf="view === 'preview'">
    <div *ngIf="!hasValidEntries" class="alert alert-warning">
      {{ 'MASS_ADD_TRANSLATIONS_NO_VALID_ENTRIES' | translate }}
    </div>

    <div class="table-responsive">
      <table class="table table-sm table-bordered align-middle">
        <thead>
          <tr>
            <th style="width: 30%">{{ 'KEY' | translate }}</th>
            <th>{{ 'VALUES' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of previewRows">
            <td>
              <span class="font-weight-bold">{{ row.key }}</span>
              <i
                *ngIf="row.keyFormatWarning"
                class="fa-solid fa-triangle-exclamation text-warning ml-1"
                placement="top"
                [ngbTooltip]="'MASS_ADD_TRANSLATIONS_KEY_FORMAT_WARNING' | translate"
              ></i>
            </td>
            <td>
              <div *ngFor="let entry of row.languages" class="d-flex align-items-baseline mb-1">
                <span class="badge badge-secondary mr-2">{{ entry.lang }}</span>
                <span *ngIf="entry.isConflict" class="text-muted text-decoration-line-through mr-2">{{
                  entry.oldValue
                }}</span>
                <span [class.text-success]="entry.isNew" [class.text-warning]="entry.isConflict">{{
                  entry.newValue
                }}</span>
              </div>
              <div *ngFor="let err of row.errors" class="text-danger small">
                <i class="fa-solid fa-circle-xmark mr-1"></i>{{ err }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="cancel()">{{ 'CANCEL' | translate }}</button>
  <button *ngIf="view === 'preview'" type="button" class="btn btn-outline-secondary" (click)="backToInput()">
    {{ 'BACK' | translate }}
  </button>
  <button
    *ngIf="view === 'input'"
    type="button"
    class="btn btn-primary"
    (click)="preview()"
    [disabled]="!rawInput.trim()"
  >
    {{ 'PREVIEW' | translate }}
  </button>
  <button
    *ngIf="view === 'preview'"
    type="button"
    class="btn btn-primary"
    (click)="confirmImport()"
    [disabled]="!hasValidEntries"
  >
    {{ 'IMPORT' | translate }}
  </button>
</div>
